import React from 'react';
import { Section } from '../../components/section';
import { shorthand } from '../../utils/css-utils';
import { ItemsColumn } from './item-column';
export const SectionItemGridHorizontal = (props) => {
    const { section, cssClass, isRtl, experiments } = props;
    const { innerPadding, outerPadding, leftColumnPadding, rightColumnPadding, spacerHeight, } = section;
    const numberOfRows = section.items.length / 2;
    return (React.createElement(React.Fragment, null, Array(Math.ceil(numberOfRows))
        .fill(0)
        .map((_, idx) => (React.createElement(Section, { key: `${section.items[idx * 2].id}_${section.items[idx * 2 + 1]?.id}`, backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
        React.createElement(ItemsColumn, { section: section, item: section.items[idx * 2], padding: innerPadding
                ? `${idx === 0 ? innerPadding.top : spacerHeight}px ${isRtl ? leftColumnPadding : rightColumnPadding} ${idx === numberOfRows - 1
                    ? innerPadding.bottom
                    : spacerHeight}px ${innerPadding.left}px`
                : '', width: section.leftColumnWidth, experiments: experiments }),
        React.createElement(ItemsColumn, { section: section, item: section.items[idx * 2 + 1], padding: innerPadding
                ? `${idx === 0 ? innerPadding.top : spacerHeight}px ${innerPadding.right}px ${idx === numberOfRows - 1
                    ? innerPadding.bottom
                    : spacerHeight}px ${isRtl ? rightColumnPadding : leftColumnPadding}`
                : '', width: section.rightColumnWidth, experiments: experiments }))))));
};
//# sourceMappingURL=section-item-grid-horizontal.js.map